import axios from "axios";

import settings from "@/settings";

import type { IAuthData, ILoginInput, IRefreshTokenInput } from "./types";

const axiosInstanceWithoutInterceptor = axios.create({
  baseURL: settings.kreaBaseApiUrl,
});

export const login = async (input: ILoginInput) => {
  const response = await axiosInstanceWithoutInterceptor.post<IAuthData>(
    "/lender/api/v1/auth/tokens",
    input,
  );

  return response.data;
};

export const refreshTokens = async (input: IRefreshTokenInput) => {
  const response = await axiosInstanceWithoutInterceptor.post<IAuthData>(
    "/lender/api/v1/auth/refresh",
    input,
  );

  return response.data;
};
